import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from 'modules/theme';
import { Alert } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { BarItems } from 'modules/theme';
import {
  DataWrapperClass,
  InsightWrapper
} from '../../styles';
import { PerPage } from 'helpers/system-config';
import {
  ModalTrigger, Button, Table, Tip,
  DataWithLoader, ControlLabel,
  ReportPagination
} from 'modules/theme';
import { modalType } from '../../../../../helpers/dotenv';
import Filter from './../../Filter';
import { WrapperData } from 'modules/theme';
import { ManageColumns } from 'modules/theme';
import { getCampaign } from 'modules/common/utils/api';


const defaultColums = [
  'PhoneNumber',
  'duration',
  'hungupCause',
  'status',
  'data'
];
export class REPORT extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `Voice CDR`;
    this.moduleUrl = `voice-cdr-report/list`;
    let selectedColumList = defaultColums;
    this.state = {
      listData: [],
      listField: [],
      configList: [],
      loading: false,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: '',
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      Filters: {},
      selectedFilter: {},
      campaign: [],
      // isToggle: false
      isActive: false,

      columnList: defaultColums,
      selectedColumList: selectedColumList,
      showColumn: false
    };
    this.bindThis();
  }
  bindThis() {
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getReportName = this.getReportName.bind(this);
    this.getData = this.getData.bind(this);
    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.open = this.open.bind(this);
    this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
    this.getFilter = this.getFilter.bind(this);
  }
  componentDidMount() {
    this.getList();
  }
  async getFilter() {
    let campaignList = await getCampaign("", 100, 1);
    // console.log("campaignList", campaignList);
    this.setState({ "campaign": campaignList })
  }

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }

  openModal() {
    this.setState({ showHide: true });
  }

  closeModal() {
    this.setState({ showHide: false });
  }

  getReportName() {
    return 'default';
  }

  handleModalShowColumn() {
    this.setState({ showColumn: !this.state.showColumn });
  }

  getSelectedColumnNames() {
    console.log(this.state.selectedColumList);
    return this.state.selectedColumList;
  }

  getData(data) {
    console.log(data);
    let selectedCampaign = [];
    if (data.selectedCampaign && data.selectedCampaign.length > 0) {
      data.selectedCampaign.map((element) => {
        if (element.value) {
          selectedCampaign.push(element.value);
        }
      })
    }

    let filter = data
    this.setState({ "Filters": filter, "currentPage": 1 })
    this.getList(1, this.state.perPageCount, filter)
  }

  downloadReport(page = 1, perPage = '', filter = '') {
    var that = this;

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;

    let tData = {
      limit: perPage,
      page_no: page,
      orderBy: '',
      order: '',
      type: 'voice',
      subType: 'voice-report',
      ...filter
    }
    this.mAPI.sendPostAPI(
      `voice-cdr-report/export/reports`,
      tData,
      data => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data.status === 'pending') {
          Alert.success(`You can download Report from Import & Export...`);
        } else {
          this.mAPI.downloadUrl(data.fileurl);
          let a = document.createElement('a');
          a.href = data.fileurl;
          a.download = data.csvfileName;
          a.click();
        }

      },
      (error, data) => {
        this.setState({ loading: false });
        console.log(`Error:`, error);
        Alert.error('Error');
      }
    );
  }

  getList(page = 1, perPage = '', filter = '') {
    var that = this;
    this.setState({ loading: true });

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;
    let tData = {
      limit: perPage,
      page_no: page,
      orderBy: '',
      order: '',
      type: 'voice',
      subType: 'voice-report',
      ...filter
    };
    this.mAPI.sendPostAPI(
      this.moduleUrl,
      tData,
      data => {
        that.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ listData: data.data, listField: data.configList, total: data.count || 0, SelectedList: [], columnList: data.config });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        that.setState({ loading: false });
        console.log(`Error:`, error);
        Alert.error('Error');
      }
    );
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map(listData => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter(e => e.selected)
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map(user => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter(e => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter(e => e.selected)
    });
  }

  onPaginationChange(page) {
    console.log('onPaginationChange', page);
    this.setState({ currentPage: page });
    this.getList(page, this.state.perPageCount, this.state.Filters);
  }

  onPerPageChooser(perPage) {
    console.log('onPerPageChooser', perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.Filters);
  }

  renderContent() {
    const { brands, history, queryParams } = this.props;
    return (
      <InsightWrapper>
        <Filter
          filterList={["renderFrom", "renderTo", "renderTimezones"]}
          getSelectedColumnNames={this.getSelectedColumnNames}
          getData={this.getData}
          history={history}
          brands={[]}
          queryParams={[]}
          selectedFilter={this.state.selectedFilter}
          setFilter={this.setFilter}
          updateFilter={this.updateFilter}
          CampaignList={this.state.campaign}
        />
      </InsightWrapper>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __('Reporting'), link: '/reporting' },
      { title: __('CDR'), link: '/reporting/voice-cdr' }
    ];
    const { Section, Header } = Wrapper.Sidebar;
    let _this = this;
    const mainContent = (
      <div style={{ "overflowX": "scroll", "margin": "10px" }} >
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              {this.state.listField.map(column => {
                return column.isDefault ? (<th>{column.lable}</th>) : "";
              }
              )}
            </tr>
          </thead>
          <tbody id="Report">
            {_this.state.listData.map(tData => {
              return (
                <tr >
                  {
                    _this.state.listField.map(column => {
                      if (column.isDefault) {
                        let result = tData[column.column];
                        if (typeof result != "string" && typeof result != "number") {
                          if (typeof result == "object") {
                            try {
                              result = JSON.stringify(result);
                            } catch (error) {

                            }
                          } else {
                            result = "-";
                          }
                        }
                        return (
                          <td style={{ "overflow": "hidden", "textOverflow": "ellipsis", "maxWidth": "186px" }} >
                            <Tip text={result} >
                              <span>{result}</span>
                            </Tip>
                          </td>
                        )
                      } else {
                        return "";
                      }
                    })
                  }
                </tr>
              )
            })}
          </tbody>
        </Table>
        {/* </Row> */}
      </div>
    );

    const editColumns = (
      <Button btnStyle="simple" size="small">
        Edit columns
      </Button>
    );

    const actionBarRight = (
      <BarItems>
        <ModalTrigger
          title="Choose which column you see"
          trigger={editColumns}
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          modalType={this.state.modalType}
        >
          <ManageColumns
            contentType="cdrReport"
            config={this.state.selectedColumList}
            // save={save}
            fields={this.state.columnList}
          />
        </ModalTrigger>

        <Button
          btnStyle="filter"
          size="small"
          onClick={() => this.open()}
        >
          <img src="/images/filter.png" style={{ width: '15px', marginRight: '5px' }} />Filters
        </Button>
        <Button
          btnStyle="default"
          size="small"
          // onClick={this.downloadReport}
          onClick={() =>
            this.downloadReport(1, "", this.state.Filters)
          }
        >
          Download
        </Button>
      </BarItems>
    );

    return (
      <div>
        <DataWrapperClass>

          {this.state.isActive && <WrapperData content={this.renderContent()} overflow={true} />}

          <WrapperData
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div>
                    <ControlLabel>{`${this.moduleName} (${this.state.total || 0})`}</ControlLabel>
                    {/* {this.state.SelectedList.length > 0 ? (
                      <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
                        <Button
                          btnStyle="danger"
                          size="small"
                          onClick={e =>
                            confirm().then(e => {
                              this.deleteAllData(e);
                            })
                          }
                          style={{
                            verticalAlign: 'middle',
                            marginLeft: '10px'
                          }}
                        // icon={'user-minus'}
                        >
                          <FiTrash2
                            style={{ fontSize: '14px', marginBottom: '-3px' }}
                          />
                        </Button>
                      </Tip>
                    ) : (
                      ''
                    )} */}
                  </div>
                }
                right={actionBarRight}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            // leftSidebar={filterList}
            // showLeftSideBar={this.state.isToggle}
            // leftSidebar={<SettingsSidebar />}
            // showLeftSideBar={leftSidebarType}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText=""
                  emptyImage="/images/empty/no_report.png"
                />
              </div>

              // const filterList = (
              //   <QuestionsContainer style={{ marginRight: '20px' }}>
              //     <Wrapper.Sidebar>
              //       <Section>
              //         <Header uppercase>Filters</Header>
              //         <SidebarList>
              //           {this.state.Filters &&
              //             this.state.Filters.map((filter, index) => {
              //               // console.log(this.state.selectedFilter);
              //               return (
              //                 <li key={filter._id}>
              //                   <a
              //                     className={
              //                       this.state.selectedFilter &&
              //                         this.state.selectedFilter._id === filter._id
              //                         ? 'active'
              //                         : ''
              //                     }
              //                     onClick={e => this.handleOnClick(filter._id)}
              //                   >
              //                     {filter.filterName}
              //                     <Button
              //                       btnStyle="link"
              //                       onClick={e =>
              //                         confirm().then(e => {
              //                           this.deletevalue(filter._id);
              //                         })
              //                       }
              //                     >
              //                       <Tip text="Delete Question">
              //                         <Icon icon="cancel-1" />
              //                       </Tip>
              //                     </Button>
              //                   </a>
              //                 </li>
              //               );
              //             })}
              //         </SidebarList>
              //       </Section>
              //     </Wrapper.Sidebar>
              //   </QuestionsContainer>
              // );
            }
          />
        </DataWrapperClass>
        {/* <DataWrapperClass>
          <Wrapper
            leftSidebar={filterList}
            showLeftSideBar={this.state.isToggle}
            content={this.renderContent()}
          />
        </DataWrapperClass> */}
      </div>
    );
  }
}

REPORT.contextTypes = {
  __: PropTypes.func
};

export default REPORT;



// WEBPACK FOOTER //
// src/modules/screens/reporting/VoiceAPiCdr/components/Report.js